import React from 'react';
import { MapPinIcon, PackageIcon, ArrowRightIcon } from 'lucide-react';
export function WarehouseCard({
  id,
  name,
  location,
  country,
  flag,
  stock,
  machines,
  onViewDetails
}) {
  // Determine color based on stock value
  const stockValue = parseInt(stock);
  const stockStatus = stockValue <= 0 ? 'empty' : stockValue < 50 ? 'low' : 'good';
  const statusConfig = {
    empty: {
      bg: 'bg-red-100',
      text: 'text-red-700',
      dot: 'bg-red-500',
      label: 'Sin stock'
    },
    low: {
      bg: 'bg-amber-100',
      text: 'text-amber-700',
      dot: 'bg-amber-500',
      label: 'Stock bajo'
    },
    good: {
      bg: 'bg-emerald-100',
      text: 'text-emerald-700',
      dot: 'bg-emerald-500',
      label: 'Stock óptimo'
    }
  };
  const config = statusConfig[stockStatus];
  return <div className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:border-blue-300 transition-all hover:shadow-lg" data-id="element-6549" data-mp="3bymjruql0kjj">
      {/* Top banner with ID and flag */}
      <div className="flex justify-between items-center px-4 py-2 bg-gray-50 border-b border-gray-200" data-id="element-6550" data-mp="1138sk24w56ca">
        <div className="flex items-center" data-id="element-6551" data-mp="wbqo343nsnmk">
          <span className={`h-6 w-6 flex items-center justify-center rounded-md font-bold text-xs ${config.bg} ${config.text}`} data-id="element-6552" data-mp="wanw0sulof52">
            {id}
          </span>
        </div>
        <span className="text-xl" data-id="element-6553" data-mp="nclp5wo6qs9v">{flag}</span>
      </div>
      {/* Main content */}
      <div className="p-4" data-id="element-6554" data-mp="1k0iafeukibrf">
        <h3 className="font-bold text-lg mb-2 line-clamp-1" data-id="element-6555" data-mp="1k0s1z6v9gqz8">{name}</h3>
        <div className="flex items-start text-gray-500 text-sm mb-4" data-id="element-6556" data-mp="1f3jk77e0yoyi">
          <MapPinIcon size={14} className="mr-1 mt-0.5 flex-shrink-0" data-id="element-6557" data-mp="1b0mvcyxw5wm4" />
          <p className="line-clamp-2" data-id="element-6558" data-mp="1b2zirrmf4z6k">{location}</p>
        </div>
        {/* Stats section */}
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-100" data-id="element-6559" data-mp="163wei9e9iwzn">
          {/* Stock indicator */}
          <div className="flex flex-col" data-id="element-6560" data-mp="3qsap6lhlz90p">
            <div className="flex items-center gap-2 mb-1" data-id="element-6561" data-mp="3qqg3h4yijcvk">
              <span className={`h-2.5 w-2.5 rounded-full ${config.dot}`} data-id="element-6562" data-mp="3s8ojjkpb0s7v"></span>
              <span className="text-sm font-medium" data-id="element-6563" data-mp="12vgoqqiofr3">{config.label}</span>
            </div>
            <div className="text-2xl font-bold" data-id="element-6564" data-mp="10j3eqvpetkd">{stock}</div>
          </div>
          {/* Machine count */}
          <div className="flex flex-col items-end" data-id="element-6565" data-mp="3na3ijj28a4id">
            <span className="text-sm text-gray-500 mb-1" data-id="element-6566" data-mp="3n8sc1bheeink">Máquinas</span>
            <div className="flex items-center" data-id="element-6567" data-mp="39i6wnwr5kquf">
              <div className={`flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 mr-2`} data-id="element-6568" data-mp="39hdrh07ue9ee">
                <PackageIcon size={16} className="text-blue-600" data-id="element-6569" data-mp="3ebi3vyzvn9mv" />
              </div>
              <span className="text-xl font-bold" data-id="element-6570" data-mp="2zmc6mgklnthm">{machines}</span>
            </div>
          </div>
        </div>
      </div>
      {/* Action button */}
      <div className="border-t border-gray-100" data-id="element-6571" data-mp="2qjb1oj7h08fj">
        <button onClick={onViewDetails} className="w-full flex items-center justify-center gap-1 py-3 text-blue-600 hover:bg-blue-50 transition-colors font-medium" data-id="element-6572" data-mp="2qkmd9575qkh7">
          Ver detalles
          <ArrowRightIcon size={16} data-id="element-6573" data-mp="2bxno5gvrw25n" />
        </button>
      </div>
    </div>;
}